export const includedIn = (list, project = (i) => i, projectValue = project) => {
    const set = new Set(Array.from(list, project));

    return (value) => set.has(projectValue(value));
};
